import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

// import ToolTip from "../../../../components/ToolTip/ToolTip"
import ToggleSwitch from "../../../../components/ToggleSwitch"
import { TableHeader } from "../../../../components/Table/Table"
import { SitesObj, useEditSiteStatusMutation, useLazyGetAllSitesQuery } from "../../SiteService"
import { TStore } from "../../../../store/Store"
import { setNumOfRows, setPage } from "../../SiteSlice"
import { useModal } from "../../../../hooks/useModal"

import edit from "../../../../assets/images/edit_new.svg"
import charger_icon from "../../../../assets/images/charger_icon.svg"
import clock from "../../../../assets/images/clock_arr_new.svg"
import delete_icon from "../../../../assets/images/delete_new.svg"
import linked_icon from "../../../../assets/images/linked_icon.svg"

import styles from "../../Sites.module.scss"
import useSitesAccess from "../../useSitesAccess"
import TagsPopover from "../../../../components/TagsPopover"
import { Countries } from "../../../../enums/dropdownValues"
import { Box, Tooltip, Typography } from "@mui/material"
import MuiPopover from "../../../../components/MuiPopover"
import useGetDeviceType from "../../../../hooks/useGetDeviceType"
import { setProcurementForm } from "../../../Logistics/LogisticsSlice"
import { setDemolitionForm, setSitesCurrentRuleValue } from "../../../Operations/OperationSlice"
import { setIsNavigated, setQueryByIds } from "../../../Projects/ProjectSlice"
import { setSitesDisplayValues } from "../../../Operations/features/Survey/SurveySlice"
import {
    setSitesCurrentRuleValue as setDemolitionSitesCurrentRuleValue,
    setSitesDisplayValues as setDemolitionSitesDisplayValues,
} from "../../../../pages/Operations/OperationSlice"
import { setIsNavigated as setDemolitionIsNavigated } from "../../../../pages/Operations/features/Demolition/DemolitionSlice"
import {
    setSitesCurrentRuleValue as setLogisticsSitesCurrentRuleValue,
    setSitesDisplayValues as setLogisticsSitesDisplayValues,
    setIsNavigated as setLogisticsIsNavigated,
} from "../../../../pages/Logistics/LogisticsSlice"
import {
    setSitesCurrentRuleValue as setProjectSitesCurrentRuleValue,
    setSitesDisplayValues as setProjectSitesDisplayValues,
    setIsNavigated as setProjectIsNavigated,
} from "../../../../pages/Projects/ProjectSlice"

const useSitesTable = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isShown, toggle } = useModal()
    const [editSiteData, setEditSiteData] = useState<SitesObj>()
    const [sortAddedOn, setSortAddedOn] = useState(false)
    const [sortAddedOnCount, setSortAddedOnCount] = useState(0)
    const { editSitesPermission, viewTagAccess, editTagAccess, deleteTagIdAccess, addTagAccess } = useSitesAccess()
    const { DemolitionFormValue } = useSelector((store: any) => store.operation)
    const { LogisticsFormValue } = useSelector((store: any) => store.Logistics)

    const [getAllSites, { data: sitesData, isFetching: isSitesLoading }] = useLazyGetAllSitesQuery()

    const [editSiteStatus] = useEditSiteStatusMutation()
    const { deviceType } = useGetDeviceType()

    const { page, numOfRows, filterValues, visibleColumns } = useSelector((store: TStore) => store.sites)
    const nameMap: any = {
        projects: "Projects",
        survey: "Survey",
        logistics: "Logistics",
        demolition: "Demolition",
    }
    const headerData: TableHeader[] = [
        {
            title: "Site ID",
        },
        {
            title: "Site Name",
        },
        {
            title: "Linked Tickets",
        },
        {
            title: "Site Address",
        },
        {
            title: "Country",
        },
        {
            title: "Pincode",
        },
        {
            title: "City",
        },
        {
            title: "State",
        },
        {
            title: "Tags",
        },
        {
            title: "Added On",
            apiSortable: {
                sortAddedOn: sortAddedOn,
                setSortAddedOn: setSortAddedOn,
                setSortAddedOnCount: setSortAddedOnCount,
            },
        },
        {
            title: "Added By",
        },
        {
            title: "Actions",
        },
    ]

    const getCountryTitleById = (id: number) => {
        return Countries.find(country => country.id === id)?.title || "-"
    }

    // const rowData = sitesData?.data?.map(d => ({
    //     "Site ID": {
    //         value: (
    //             <div className={styles.charger_icon_container}>
    //                 {d.site_type === "Station" && (
    //                     <ToolTip
    //                         containerClass={styles.tooltip_container}
    //                         trigger={<img src={charger_icon} alt="station" />}
    //                         data={"This Site is also a station"}
    //                         width={"170px"}
    //                         tooltipPadding="8px"
    //                         spaceFromLeft="40px"
    //                     />
    //                 )}
    //                 {d.site_id}
    //             </div>
    //         ),
    //     },
    //     "Site Name": { value: d.name, truncateText: true },
    //     "Linked Tickets": {
    //         value: d?.total_linked_count === 0 ? "-" : null,
    //         tooltip: {
    //             trigger: d?.total_linked_count,
    //             type: "linked-projects",
    //             linkedData: Object?.keys?.(d?.linked_projects || {})
    //                 ?.filter(key => key !== "count")
    //                 ?.map(key => ({
    //                     id: key,
    //                     name: nameMap?.[key] || key,
    //                     count: d?.linked_projects?.count[key] || 0,
    //                 })),
    //             site_id: d?.id,
    //             site_name: d?.name,
    //         },
    //     },
    //     "Site Address": { value: d.address, truncateText: true },
    //     Country: { value: getCountryTitleById(d?.country_id) },
    //     Pincode: { value: <span>{d.pincode}</span> },
    //     City: { value: <span>{d.city}</span> },
    //     State: { value: <span>{d.state}</span> },
    //     Tags: {
    //         value: (
    //             <TagsPopover
    //                 tableDisplay={true}
    //                 ticket_id={d?.id}
    //                 module_name={"sites"}
    //                 primaryTag={d?.tags?.primary[0]}
    //                 ticket_type={"Sites"}
    //                 selectedTags={[...(d?.tags?.others || []), ...(d?.tags?.primary || [])]}
    //                 isLoading={isSitesLoading}
    //                 tagAccess={{ addTagAccess, deleteTagIdAccess, editTagAccess, viewTagAccess }}
    //             />
    //         ),
    //     },
    //     "Added On": { value: d.created_at },
    //     "Added By": { value: <span>{d.added_by}</span> },
    //     Actions: {
    //         value: (
    //             <div className={styles.action_cell}>
    //                 {editSitesPermission && (
    //                     <ToolTip
    //                         containerClass={styles.tooltip_container}
    //                         trigger={
    //                             <img
    //                                 src={edit}
    //                                 alt="edit"
    //                                 onClick={() => {
    //                                     toggle()
    //                                     setEditSiteData(d)
    //                                 }}
    //                             />
    //                         }
    //                         data={"Edit"}
    //                         width={"60px"}
    //                         tooltipPadding="8px"
    //                         spaceFromLeft="40px"
    //                     />
    //                 )}
    //                 <ToolTip
    //                     containerClass={styles.tooltip_container}
    //                     trigger={
    //                         <img
    //                             src={clock}
    //                             alt="history"
    //                             onClick={() => {
    //                                 navigate(`/SiteHistory?ticket_id=${d?.id}`, {
    //                                     state: { sub_module: "Accounts", detail: d },
    //                                 })
    //                             }}
    //                         />
    //                     }
    //                     data={"History"}
    //                     width={"60px"}
    //                     tooltipPadding="8px"
    //                     spaceFromLeft="40px"
    //                 />
    //                 <ToggleSwitch
    //                     key={0}
    //                     style={{
    //                         opacity: d?.is_active ? 1 : 0.7,
    //                     }}
    //                     checked={Boolean(d?.is_active)}
    //                     toggleSwitch={e => {
    //                         editSiteStatus({
    //                             site_id: d.id,
    //                             status: e.target.checked ? 1 : 0,
    //                         })
    //                     }}
    //                 />
    //             </div>
    //         ),
    //     },
    // }))

    const setPageNo = (page: number) => {
        dispatch(setPage(page))
    }

    const handleRedirect = (site_id: number, name: string, site_name?: string, linkedIds?: number[]) => {
        if (name === "survey") {
            dispatch(
                setSitesDisplayValues([
                    {
                        id: site_id,
                        name: site_name,
                    },
                ])
            )
            dispatch(
                setSitesCurrentRuleValue([
                    {
                        id: site_id,
                        title: site_name,
                    },
                ])
            )
            dispatch(setIsNavigated(true))

            navigate("/Survey", {
                state: {
                    redirectedSiteId: site_id,
                    site_name: site_name,
                },
            })
        } else if (name === "demolition") {
            dispatch(
                setDemolitionSitesDisplayValues([
                    {
                        id: site_id,
                        name: site_name,
                    },
                ])
            )
            dispatch(
                setDemolitionSitesCurrentRuleValue([
                    {
                        id: site_id,
                        title: site_name,
                    },
                ])
            )
            dispatch(setDemolitionIsNavigated(true))
            navigate("/Demolition", {
                state: {
                    redirectedSiteId: site_id,
                    site_name: site_name,
                },
            })
        } else if (name === "logistics") {
            dispatch(
                setLogisticsSitesDisplayValues([
                    {
                        id: site_id,
                        name: site_name,
                    },
                ])
            )
            dispatch(
                setLogisticsSitesCurrentRuleValue([
                    {
                        id: site_id,
                        title: site_name,
                    },
                ])
            )
            dispatch(setLogisticsIsNavigated(true))
            navigate("/Logistics", {
                state: {
                    redirectedSiteId: site_id,
                    site_name: site_name,
                },
            })
        } else if (name === "projects") {
            dispatch(
                setProjectSitesDisplayValues([
                    {
                        id: site_id,
                        name: site_name,
                    },
                ])
            )
            dispatch(
                setProjectSitesCurrentRuleValue([
                    {
                        id: site_id,
                        title: site_name,
                    },
                ])
            )
            dispatch(setProjectIsNavigated(true))
            navigate("/Projects", {
                state: {
                    redirectedSiteId: site_id,
                    site_name: site_name,
                },
            })
        }
    }

    const columnDefs = [
        {
            headerName: "S.No.",
            sortable: false,
            width: 20,
            cellRenderer: (params: any) => {
                const serialNo = (page - 1) * numOfRows + (params.node?.rowIndex ?? 0) + 1
                const isStation = params.data?.site_type === "Station"
                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        <Box component="span">{serialNo}</Box>

                        {isStation && (
                            <Tooltip title="This Site is also a station">
                                <Box component="span">
                                    <img src={charger_icon} alt="station" />
                                </Box>
                            </Tooltip>
                        )}
                    </Box>
                )
            },
        },

        {
            headerName: "Site ID",
            field: "site_id",
            sortable: true,
            width: 20,
        },
        {
            headerName: "Site Name",
            field: "site_name",
            sortable: true,
        },
        {
            headerName: "Linked Tickets",
            field: "linked_tickets",
            sortable: false,
            width: 20,
        },
        {
            headerName: "Site Address",
            field: "site_address",
            sortable: true,
        },
        {
            headerName: "Country",
            field: "country",
            sortable: true,
        },
        {
            headerName: "State",
            field: "state",
            sortable: true,
        },
        {
            headerName: "City",
            field: "city",
            sortable: true,
        },
        {
            headerName: "Pincode",
            field: "pincode",
            sortable: true,
        },
        {
            headerName: "Tags",
            field: "tags",
            sortable: false,
        },
        ...(visibleColumns.find(i => i.name === "CSMS ID")?.visible
            ? [
                  {
                      headerName: "CSMS ID",
                      field: "csms_station_id",
                      sortable: true,
                  },
              ]
            : []),
        ...(visibleColumns.find(i => i.name === "Added On")?.visible
            ? [
                  {
                      headerName: "Added On",
                      field: "added_on",
                      sortable: true,
                  },
              ]
            : []),
        ...(visibleColumns.find(i => i.name === "Added By")?.visible
            ? [
                  {
                      headerName: "Added By",
                      field: "added_by",
                      sortable: true,
                  },
              ]
            : []),

        {
            headerName: "Actions",
            field: "actions",
            width: 60,
            sortable: false,
        },
    ]
    const rowData = sitesData?.data?.map(d => ({
        site_id: d?.site_id,
        site_type: d?.site_type,
        site_name: d?.name,
        linked_tickets:
            d?.total_linked_count === 0 || Object.keys(d?.linked_projects || {}).length === 0 ? (
                "-"
            ) : (
                <MuiPopover
                    displayText={
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box component={"span"} color="#0430C0" className={"text-underline"}>
                                {d?.total_linked_count}
                            </Box>
                            <img src={linked_icon} alt="linked_icon" />
                        </Box>
                    }>
                    <Box display={"flex"} flexDirection={"column"} gap={1} padding={"8px 12px"}>
                        {d.total_linked_count > 0 && (
                            <>
                                <Typography fontSize={"12px"} fontWeight={500} color={"statiqOrange"}>
                                    Linked Tickets
                                </Typography>
                                {Object.keys(d.linked_projects?.count || {})
                                    ?.filter(key => key !== "total_linked_projects")
                                    .map(key => (
                                        <Box key={key} display={"flex"} gap={2} justifyContent={"space-between"}>
                                            <Typography component={"span"} color="#70758d" fontSize={"11px"}>
                                                {key}
                                            </Typography>
                                            <Typography
                                                component={"span"}
                                                color="#0430C0"
                                                onClick={() =>
                                                    handleRedirect(d.id, key, d?.name, d.linked_projects?.[key])
                                                }
                                                className={
                                                    d.linked_projects?.count?.[key] > 0
                                                        ? "text-underline cursor-pointer"
                                                        : ""
                                                }
                                                fontSize={"11px"}>
                                                {d.linked_projects?.count?.[key] || "-"}
                                            </Typography>
                                        </Box>
                                    ))}
                            </>
                        )}
                    </Box>
                </MuiPopover>
            ),
        site_address: d?.address,
        country: getCountryTitleById(d?.country_id),
        state: d?.state,
        city: d?.city,
        pincode: d?.pincode,
        tags: (
            <TagsPopover
                tableDisplay={true}
                ticket_id={d?.id}
                module_name={"sites"}
                primaryTag={d?.tags?.primary[0]}
                ticket_type={"Sites"}
                selectedTags={[...(d?.tags?.others || []), ...(d?.tags?.primary || [])]}
                isLoading={isSitesLoading}
                tagAccess={{ addTagAccess, deleteTagIdAccess, editTagAccess, viewTagAccess }}
            />
        ),
        csms_station_id: d?.csms_station_id || "-",
        added_on: d?.created_at,
        added_by: d?.added_by,
        actions: (
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} gap={1}>
                {editSitesPermission && (
                    <img
                        src={edit}
                        alt="edit"
                        onClick={() => {
                            toggle()
                            setEditSiteData(d)
                        }}
                    />
                )}
                <img
                    src={clock}
                    alt="history"
                    onClick={() => {
                        navigate(`/SiteHistory?ticket_id=${d?.id}`, {
                            state: { sub_module: "Accounts", detail: d },
                        })
                    }}
                />
                <ToggleSwitch
                    checked={d?.is_active ? true : false}
                    toggleSwitch={() => {
                        editSiteStatus({
                            site_id: d.id,
                            status: d?.is_active ? 0 : 1,
                        })
                    }}
                />
            </Box>
        ),
    }))

    const setVisibleRows = (val: number) => {
        dispatch(setNumOfRows(val))
    }

    useEffect(() => {
        const { siteType, state, city, status, addedBy, tags, country_id, ...filters } = filterValues
        const stateFilter = JSON.stringify(state?.length ? state.map(i => i.id) : [])
        const cityFilter = JSON.stringify(city?.length ? city.map(i => i.id) : [])
        const statusFilter = status?.id === 0 || status?.id === 1 ? status.id : ""
        const siteTypeFilter = siteType?.title?.toLowerCase() || ""
        const addedByFilter = JSON.stringify(addedBy?.length ? addedBy.map(i => i.id) : [])
        const tagsFilter = JSON.stringify(tags?.length ? tags.map(i => i.id) : [])
        const siteCountryFilter = country_id?.id

        const sortParams: Record<string, boolean> = sortAddedOn
            ? { created_at: true }
            : sortAddedOnCount > 0
              ? { created_at: false }
              : { updated_at: true }

        getAllSites({
            page,
            per_page: numOfRows,
            state: stateFilter,
            city: cityFilter,
            site_type: siteTypeFilter,
            status: statusFilter,
            added_by: addedByFilter,
            tag_ids: tagsFilter,
            country_id: siteCountryFilter,
            ...sortParams,
            ...filters,
            showOnlyActive: false,
        })
    }, [page, numOfRows, sortAddedOn, JSON.stringify(filterValues)])

    return {
        states: {
            headerData,
            rowData,
            isSitesLoading,
            page,
            numOfRows,
            totalPages: sitesData?.totalPages,
            editSiteData,
            isShown,
            sortAddedOn,
            sortAddedOnCount,
            columnDefs,
            deviceType,
        },
        functions: {
            setPageNo,
            setVisibleRows,
            setEditSiteData,
            toggle,
        },
    }
}

export default useSitesTable
